/* eslint-disable */
import View from './view';

export default class PanelView extends View {
    constructor(controller, container, config) {
        super(controller, container, config);
        this.data = config.data;
        this.template = config.templates || function(featureValues, featureId) { return `Feature ID: ${featureId}` };
        this.transitionDuration = this.config.transitionDuration || 500;

        this.baseClassName = 'map__panel-view';
        this.hiddenClassName = `${this.baseClassName}--hidden`;

        this.el = document.createElement('div');
        this.el.className = `${this.baseClassName} ${this.hiddenClassName}`;
        this.applyTransitionStyle(this.transitionDuration);

        this.controller.addTopicHandler('reset-map', this.hide.bind(this));
        this.controller.addTopicHandler('hide-tooltip', this.hide.bind(this));
        this.controller.addTopicHandler('focus-feature', this.onFocusFeature.bind(this));
    }

    // @TODO callback
    render() {
        this.container.appendChild(this.el);
    }

    renderData() {
        if (this.selectedFeature) {
            const feature = this.data[this.selectedFeature];
            if (feature) {
                this.populatePanelContent(feature, this.selectedFeature);
            }
        }
    }

    onFocusFeature(event) {
        const feature = event.feature;
        // Don't show panel for whole region, i.e. feature.type === 'FeatureCollection'
        if (feature.type === 'Feature' && feature.id !== null) {
            // @todo this.template should probably just be passed feature in case FeatureModel changes at some point
            this.populatePanelContent(feature.properties.values, feature.id);
            this.emit('panel-update', { container: this.container, feature: feature });
            this.show(feature.id);
        }
        else if (feature.id !== null) {
            this.hide();
        }
    }

    populatePanelContent(featureProperties, featureId) {
        this.el.innerHTML = this.template(featureProperties, featureId);
    }

    show(featureId) {
        this.el.classList.remove(this.hiddenClassName);
        this.selectedFeature = featureId.toUpperCase();
    }

    hide() {
        this.el.classList.add(this.hiddenClassName);
        this.selectedFeature = false;
    }

    applyTransitionStyle(transitionDuration) {
        // this line means all transition durations applied to the panel using CSS will be overriden (sorry)
        this.el.style.transitionDuration = `${transitionDuration / 1000}s`;
    }
}
